import { typedQueryClient, useTypedMutation } from "hooks";
import { useShowPendingChecklistsNotifications } from "modules/AppointmentDetails/hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { InterventionFormAttachment } from "components";
import type { Checklist, Intervention, InterventionElement, VehicleTyreReplacement } from "models";

export type AddInterventionPayload = {
  customer_ok: boolean;
  description: string;
  title: string;
  price: number;
  appointment_id: number;
  question_result_id?: number;
  question_result_status?: number; // TODO: should not be here, but currently has to be passed as we use this payload to add the intervention optimisticly
  dms_nr: string;
  elements?: InterventionElement[];
  replacements?: VehicleTyreReplacement[];
  check_in_result_id?: number;
  check_in_remark_id?: number;
  attachments?: InterventionFormAttachment[];
  snooze_id?: number;
  diagnose_overview_remark_id?: number;
  keylocker_remark_id?: number;
  kiosk_remark_id?: number;
  reference_nr?: string;
  rdw_recall_id?: string;
  pon_recall_id?: string;
  recalls_id?: string;
  visible_to_customer?: boolean;
  is_local?: boolean;
};

type AddInterventionResponse = {
  id: number;
  added_checklists?: Checklist[];
  not_added_checklists?: Checklist[];
};

export const useAddInterventionMutation = () => {
  const { showPendingChecklistsNotifications } = useShowPendingChecklistsNotifications();

  return useTypedMutation<AddInterventionPayload, AddInterventionResponse>({
    mutationFn: async payload => (await ApiInstance.post("/interventions/add", payload)).data,
    onSuccess: (payload, { id, added_checklists, not_added_checklists }) => {
      showPendingChecklistsNotifications(added_checklists, not_added_checklists);

      // TODO: check with BE to return the whole created intervention so we can remove the casting
      const intervention = { id, ...payload, replacements: payload.replacements?.map(replacement => ({ ...replacement, intervention_id: id })) } as Intervention;
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment || appointment.interventions?.some(i => i.id === id)) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, interventions: [...(appointment.interventions ?? []), intervention] });
    }
  });
};
